import { Component, OnInit, TemplateRef, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from "@angular/router";
import { AppConfig } from "app/app.config";
import { LoaderService } from "app/services/loader.service";
import { APIService, pgfActivityType } from 'app/services/api.service';
import { AuthenticationService, reRgType } from 'app/services/auth.service';
import { NgbModal, NgbPagination, NgbPaginationFirst, NgbPaginationPrevious, NgbPaginationNext, NgbPaginationLast, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { AdvisorContactComponent } from "app/modules/shared/advisor-contact.component";
import { ExcelService } from "app/services/excel.service";
import { MenuComponent } from '../../../components/Controls/menu/menu.component';
import { PGFChartComponent } from '../../../components/NWMCharts/pgfchart.component';
import { FormsModule } from '@angular/forms';
import { NgClass, NgTemplateOutlet, DecimalPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { AdvisorContactComponent as AdvisorContactComponent_1 } from '../../shared/advisor-contact.component';
import { MinusSignToParens } from 'app/pipes/minus-sign-to-parens.pipe';

type sortFieldType = 'CharityName' | 'AmountCAD';
type dateRangeOptionType = {monthsRange: number, text: string};

@Component({
    templateUrl: './impact.component.html',
    styleUrls: [`./impact.component.scss`],
    imports: [MenuComponent, PGFChartComponent, FormsModule, NgClass, NgTemplateOutlet, NgbPagination, NgbPaginationFirst, NgbPaginationPrevious, NgbPaginationNext, NgbPaginationLast, RouterLink, NgbTooltip, AdvisorContactComponent_1, MinusSignToParens, DecimalPipe, CurrencyPipe, DatePipe]
})

export class PgfImpactComponent implements OnInit {
  private config = inject(AppConfig);
  private loaderService = inject(LoaderService);
  private excel = inject(ExcelService);
  private api = inject(APIService);
  route = inject(ActivatedRoute);
  auth = inject(AuthenticationService);
  modalService = inject(NgbModal);

  public reRg?: reRgType;
  public page = 1;
  public pageSize: number = this.config.document.documentPageSize;
  public pageOptions: number[] = Array.from({length: 10}, (v, k) => (k + 1) * 10);
  public totalPages = 1;
  public dataLoaded = false;

  public dateRange = -1;
  public dateRangeOptions: dateRangeOptionType[] = [
    {monthsRange: -1, text: 'All Time'},
    {monthsRange: 0, text: 'Year To Date'},
    {monthsRange: 1, text: 'Last Month'},
    {monthsRange: 3, text: 'Last 3 Months'},
    {monthsRange: 6, text: 'Last 6 Months'},
    {monthsRange: 12, text: 'Last 12 Months'},
  ];

  public sortField: sortFieldType = 'CharityName';
  public sortDir = 1;

  public dataList: pgfActivityType[] = [];
  public filteredData: pgfActivityType[] = [];
  public pagedData: pgfActivityType[] = [];

  public modalTitle = '';
  public modalAction: 'PgfDonation' | 'PgfGrant' |'MessageAdvisor' = 'PgfGrant';

  public inceptionGrants = 0;

  public charityName = '';
  public charityType = '';
  public charityAmountCAD = 0;
  public charityPercent = 0;
  public yearGrants:number[] = [];
  public chartLabels:string[] = [];
  public firstYear = 2000;
  public minYears = 5;

  public total = 0;
  public today:Date = new Date();
  public AreaImpact2show = 4;

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['impact'] == 'other-impact') {
        this.loadOtherImpacts();
      } else {
        this.loadImpact(params['impact']);
      }
    });
  }

  loadOtherImpacts() {

    this.dataLoaded = false;
    this.loaderService.display(true, 'activities');

    this.reRg = this.auth.getCurrentReRg()!;

    this.api.getPgfActivityByReRgId(this.reRg!.ReRgId).subscribe({
      next: res => {
        let impactItem: pgfActivityType[] = [];
        const skipImapcts: string[] = [];
        res.forEach(a => {
          if (a.ActivityType === 'Grant') {
            if (a.CharityType != '' && a.CharityType != 'Other') {
              const charityType = impactItem.find(g => g.CharityType === a.CharityType);
              if (charityType) {
                charityType.AmountCAD += a.AmountCAD;
              } else {
                impactItem.push(Object.assign({}, a));
              }
            }
          }
        });

        impactItem.sort((a,b)=>a.AmountCAD>b.AmountCAD?-1:1);
        impactItem = impactItem.slice(0,this.AreaImpact2show);
        impactItem.forEach(i => {
          if (i.CharityType != '' && i.CharityType != 'Other') {
            skipImapcts.push(i.CharityType);
          }
        });

        const year = (new Date()).getFullYear();
        this.loaderService.display(false, 'activities');
        this.dataList = [];
        this.charityAmountCAD = 0;
        this.yearGrants = Array.from({length:year-this.firstYear+1},()=>0);
        this.chartLabels = Array.from({length:year-this.firstYear+1},(v,k)=>''+(this.firstYear+k));
        let minYear = year;
        res.forEach(f=>{
          if (f.ActivityType == 'Grant') {
            if(skipImapcts.indexOf(f.CharityType) === -1 || f.CharityType == '') {
              this.charityName = f.CharityName;
              this.charityAmountCAD += f.AmountCAD;
              this.charityType = f.CharityType;

              const y = +f.ActivityDate.split('-')[0];
              const index = y - this.firstYear;
              if (index>=0 && index<=year) {
                if (y<minYear) minYear = y;
                this.yearGrants[index] += f.AmountCAD;
              }
              this.dataList.push({...f});
            }

            this.inceptionGrants += f.AmountCAD;
          }
        })
        let minIndex = minYear - this.firstYear;
        if (this.yearGrants.length - minIndex < this.minYears) {
          /* show at least 'minYears' number of data points
             even if there were no grants - only because
             the chart is wide and it doesn't look good if it's only 1 or 2 bars
          */
          minIndex = this.yearGrants.length - this.minYears;
        }
        if (minIndex>0) {
          this.yearGrants = this.yearGrants.slice(minIndex);
          this.chartLabels = this.chartLabels.slice(minIndex);
        }
        this.charityPercent = Math.round(this.charityAmountCAD*10000/this.inceptionGrants)/100;

        this.filterData();
        this.dataLoaded = true;
      },
      error: () => this.loaderService.display(false, 'activities')
    });
  }

  loadImpact(impact:string) {

    let checkImapact :string[] = [];
    this.dataLoaded = false;
    this.loaderService.display(true, 'activities');
    impact = decodeURIComponent(impact);
    if (impact === 'Other') {
      checkImapact = ['', 'Other'];
    } else {
      checkImapact = [impact];
    }
    this.reRg = this.auth.getCurrentReRg()!;

    this.api.getPgfActivityByReRgId(this.reRg!.ReRgId).subscribe({
      next: res => {
        const year = (new Date()).getFullYear();
        this.loaderService.display(false, 'activities');
        this.dataList = [];
        this.charityAmountCAD = 0;
        this.yearGrants = Array.from({length:year-this.firstYear+1},()=>0);
        this.chartLabels = Array.from({length:year-this.firstYear+1},(v,k)=>''+(this.firstYear+k));
        let minYear = year;
        res.forEach(f=>{
          if (f.ActivityType == 'Grant') {
            if(checkImapact.indexOf(f.CharityType) !== -1) {
              this.charityName = f.CharityName;
              this.charityAmountCAD += f.AmountCAD;
              this.charityType = f.CharityType;

              const y = +f.ActivityDate.split('-')[0];
              const index = y - this.firstYear;
              if (index>=0 && index<=year) {
                if (y<minYear) minYear = y;
                this.yearGrants[index] += f.AmountCAD;
              }
              this.dataList.push({...f});
            }

            this.inceptionGrants += f.AmountCAD;
          }
        })
        let minIndex = minYear - this.firstYear;
        if (this.yearGrants.length - minIndex < this.minYears) {
          /* show at least 'minYears' number of data points
             even if there were no grants - only because
             the chart is wide and it doesn't look good if it's only 1 or 2 bars
          */
          minIndex = this.yearGrants.length - this.minYears;
        }
        if (minIndex>0) {
          this.yearGrants = this.yearGrants.slice(minIndex);
          this.chartLabels = this.chartLabels.slice(minIndex);
        }
        this.charityPercent = Math.round(this.charityAmountCAD*10000/this.inceptionGrants)/100;

        this.filterData();
        this.dataLoaded = true;
      },
      error: () => this.loaderService.display(false, 'activities')
    });
  }

  filterData() {
    let startDate = '';
    let filteredDate: pgfActivityType[] = [];
    this.today = new Date();
    this.filteredData = [];
    if (this.dateRange===0) {
      startDate = this.today.getFullYear() + '-01-01';
    }
    if (this.dateRange>0) {
      this.today.setMonth(this.today.getMonth() - this.dateRange);
      startDate = this.today.getFullYear() + '-' + (this.today.getMonth()+1).toString().padStart(2, '0') + '-' + this.today.getDate();
    }

    filteredDate = this.dataList.filter(f =>
      (startDate=='' || f.ActivityDate >= startDate)
    )

    filteredDate.forEach(f=>{
      if (f.ActivityType == 'Grant') {
        const found = this.filteredData.find(g=>g.CharityName === f.CharityName);
        if (found) {
          found.AmountCAD+= f.AmountCAD;
        } else {
          this.filteredData.push({
            ...f
          });
        }
      }
    });

    this.total = 0;
    this.filteredData.forEach(f => {
      this.total+= f.AmountCAD;
    });

    this.sortData();
    return true;
  }

  toggleSort(field: sortFieldType = 'CharityName') {
    if (this.sortField == field) {
      this.sortDir = 0-this.sortDir;
    } else {
      this.sortField = field;
      this.sortDir = 1;
    }
    this.sortData();
  }

  sortData() {
    this.filteredData.sort((a,b)=>
      (a[this.sortField] || '') > (b[this.sortField] || '') ? 0-this.sortDir :
        (a[this.sortField] || '') < (b[this.sortField] || '') ? this.sortDir :
          a['CharityName'].localeCompare(b['CharityName'])
    )
    this.setPage(1);
  }

  setPage(page: null | number = null) {
    if (page) this.page = page > 0 ? +page : 1;
    const l = this.filteredData.length;
    const p = this.pageSize>0 ? +this.pageSize : l;
    if (p<l) {
      this.totalPages = p ? Math.ceil(l / p) : 1;
      if (this.totalPages < this.page) this.page = this.totalPages;
      const s = (this.page-1) * p;
      const e = s+p > l ? l : s+p;
      this.pagedData = this.filteredData.slice(s, e);
    } else {
      this.totalPages = 1;
      this.pagedData = this.filteredData;
    }
  }

  openModalToContactAdvisor(content: TemplateRef<AdvisorContactComponent>, type: 'PgfDonation'|'PgfGrant'|'MessageAdvisor') {
    this.modalTitle = type == 'MessageAdvisor' ? 'Contact Advisory Team':
      type == 'PgfDonation' ? 'Request to Donate to Fund' :
        'Request to Send Grant to Charity';
    this.modalAction = type;
    this.modalService.open(content, { size: 'lg' })
  }
}
